export class JsonRpcError extends Error {
    constructor(message, code, data) {
        super(message);
        this.code = code;
        this.data = data;
        this.name = 'JsonRpcError';
    }
}
let requestId = 0;
export class JsonRpcClient {
    constructor(url) {
        this.url = url;
    }
    async call(method, params) {
        const response = await fetch(this.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                jsonrpc: '2.0',
                id: ++requestId,
                method,
                params,
            }),
        });
        if (!response.ok) {
            throw new Error(`RPC HTTP error: ${response.status} ${response.statusText}`);
        }
        const json = await response.json();
        if (json.error) {
            throw new JsonRpcError(json.error.message, json.error.code, json.error.data);
        }
        return json.result;
    }
    /** Execute a read-only contract call (eth_call) */
    async ethCall(to, data, from, value, blockTag = 'latest') {
        const callObj = { to, data };
        if (from)
            callObj.from = from;
        if (value)
            callObj.value = '0x' + value.toString(16);
        return this.call('eth_call', [callObj, blockTag]);
    }
    async getTransactionReceipt(txHash) {
        return this.call('eth_getTransactionReceipt', [txHash]);
    }
    async getTransaction(txHash) {
        return this.call('eth_getTransactionByHash', [txHash]);
    }
    async getBlockByNumber(blockNumber, fullTxs = false) {
        return this.call('eth_getBlockByNumber', [blockNumber, fullTxs]);
    }
}
